import Application from "../../Application";
import GetBusinessRulesInteractor from "./GetBusinessRulesInteractor";
import BusinessRulesPresenter, {
  IBusinessRulesPresenter
} from "../../presenter/evaluation/BusinessRulesPresenter";

export default class ShowBusinessRulesInteractor {
  private application: Application;
  private getBusinessRules: GetBusinessRulesInteractor;
  private output?: IBusinessRulesPresenter;

  constructor(application, getBusinessRules) {
    this.application = application;
    this.getBusinessRules = getBusinessRules;
  }

  execute() {
    this.output = BusinessRulesPresenter({
      application: this.application,
      initialState: {
        businessRules: []
      }
    });

    this.getBusinessRules.execute().then(this.output.setBusinessRules);

    return this.output;
  }
}
